import React from 'react';
import { Input, Label, Select_simple } from "./ui";

const TabIV_Infra = ({ data, onChange }) => { //data = {}

	// Función manejadora genérica para inputs de texto/select
	const handleChange = (e) => {
		const { name, value } = e.target;
		onChange({ ...data, [name]: value });
	};

	// Función para checkboxes (instalaciones y servicios)
	const handleCheck = (e) => {
		const { name, checked } = e.target;
		onChange({ ...data, [name]: checked });
	};
	console.log("Datos en TabD:", data)

	return (
		<div className="space-y-8 p-4">

			{/* 1. INSTALACIONES DEPORTIVAS (Checkboxes) */}
			<section>
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					Infraestructura deportiva
				</h3>
				<h3 className="text-lg font-bold mb-4 border-b pb-2">Instalaciones Deportivas</h3>
				<div className="grid grid-cols-1 md:grid-cols-4 gap-4">
					{[
						{ id: 'canchaFutbol', label: 'Cancha de fútbol' },
						{ id: 'canchaFutbol_5_7', label: 'Cancha de fútbol 5 / 7' },
						{ id: 'canchaBasket', label: 'Cancha de básquet' },
						{ id: 'canchaVoley', label: 'Cancha de vóley' },
						{ id: 'canchaHockey', label: 'Cancha de hockey' },
						{ id: 'canchasTenis', label: 'Canchas de tenis' },
						{ id: 'pistaAtletismo', label: 'Pista de atletismo' },
						{ id: 'gimnasio', label: 'Gimnasio cubierto' },
						{ id: 'natatorio', label: 'Natatorio' },
						{ id: 'salonArtesMarciales', label: 'Salón de artes marciales' },
						{ id: 'pistaPatin', label: 'Pista de patín' }
					].map(item => (
						<div key={item.id} className="flex items-center space-x-2">
							<input
								type="checkbox"
								id={item.id}
								name={item.id}
								// Usamos la protección !! para asegurar un booleano
								checked={!!data[item.id]}
								onChange={handleCheck}
							/>
							<Label htmlFor={item.id} className="cursor-pointer text-sm font-medium">
								{item.label}
							</Label>
						</div>
					))}
				</div>
				<div className="mt-4">
					<Label>Otros (detallar)</Label>
					<Input
						name="otrasInstalaciones"
						value={data.otrasInstalaciones || ''}
						onChange={handleChange}
						placeholder="Ej: Cancha de Bochas, Frontón..."
					/>
				</div>
			</section>
			{/* 1.2 INSTALACIONES COMPLEMENTARIAS */}
			<section className="mt-8">
				<h3 className="text-lg font-bold mb-4 border-b pb-2 text-gray-700">
					Instalaciones Complementarias
				</h3>
				<div className="grid grid-cols-1 md:grid-cols-4 gap-4">
					{[
						{ id: 'vestuarios', label: 'Vestuarios' },
						{ id: 'sanitarios', label: 'Sanitarios' },
						{ id: 'iluminacionDeportiva', label: 'Iluminación deportiva' },
						{ id: 'tribunas', label: 'Tribunas' },
						{ id: 'playonDeportivo', label: 'Playón deportivo' },
						{ id: 'buffetCantina', label: 'Buffet o cantina' },
						{ id: 'sum', label: 'Salón de Usos Múltiples (SUM)' },
						{ id: 'oficinasAdmin', label: 'Oficinas administrativas' },
						{ id: 'espaciosVerdes', label: 'Espacios verdes' },
						{ id: 'estacionamiento', label: 'Estacionamiento' },
						{ id: 'depositos', label: 'Depósitos / Utilería' },
					].map(item => (
						<div key={item.id} className="flex items-center space-x-2 hover:bg-gray-50 p-1 rounded transition-colors">
							<input
								type="checkbox"
								id={item.id}
								name={item.id}
								// Usamos la protección !! para asegurar un booleano
								checked={!!data[item.id]}
								onChange={handleCheck}
								className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
							/>
							<Label htmlFor={item.id} className="cursor-pointer text-sm font-medium select-none">
								{item.label}
							</Label>
						</div>
					))}
				</div>
			</section>

			{/* 2. ESTADO GENERAL */}
			<section className="bg-gray-50 p-4 rounded-lg">
				<Label className="text-md font-semibold">Estado general de la infraestructura</Label>
				<Select_simple
					name="estadoGeneral"
					value={data.estadoGeneral || ''}
					onChange={handleChange}
					options={[
						{ value: 'muy_bueno', label: 'Muy Bueno' },
						{ value: 'bueno', label: 'Bueno' },
						{ value: 'regular', label: 'Regular' },
						{ value: 'refaccion_urgente', label: 'Requiere refacción urgente' },
					]}
					placeholder="Seleccionar..."
				/>
			</section>

			{/* 3. SERVICIOS BÁSICOS (Lógica de Radio/Select) */}
			<section className="mb-10">
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					Servicios e instalaciones del predio
				</h3>

				<div className="bg-slate-50 p-6 rounded-xl border border-slate-200 space-y-8">

					{/* Servicios Básicos */}
					<div>
						<Label className="mb-4 block font-bold text-blue-700">Servicios Básicos</Label>
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
							<div>
								<Label className="text-xs">Energía Eléctrica</Label>
								<Select_simple
									name="srv_energia"
									value={data.srv_energia || ''}
									onChange={handleChange}
									options={[
										{ value: 'red_publica', label: 'Red Pública' },
										{ value: 'generador', label: 'Generador Propio' },
										{ value: 'no_posee', label: 'No posee' },
									]}
									placeholder="Seleccionar..."
								/>
							</div>
							<div>
								<Label className="text-xs">Agua</Label>
								<Select_simple
									name="srv_agua"
									value={data.srv_agua || ''}
									onChange={handleChange}
									options={[
										{ value: 'red_publica', label: 'Red Pública' },
										{ value: 'perforacion', label: 'Perforación / Bomba' },
										{ value: 'otro', label: 'Otro' },
										{ value: 'no_posee', label: 'No posee' },
									]}
									placeholder="Seleccionar..."
								/>
							</div>
							<div>
								<Label className="text-xs">Gas</Label>
								<Select_simple
									name="srv_gas"
									value={data.srv_gas || ''}
									onChange={handleChange}
									options={[
										{ value: 'natural', label: 'Red de gas natural' },
										{ value: 'envasado', label: 'Gas envasado' },
										{ value: 'no_posee', label: 'No posee' },
									]}
									placeholder="Seleccionar..."
								/>
							</div>
							<div>
								<Label className="text-xs">Cloacas</Label>
								<Select_simple
									name="srv_cloacas"
									value={data.srv_cloacas || ''}
									onChange={handleChange}
									options={[
										{ value: 'red_publica', label: 'Red Pública' },
										{ value: 'pozo', label: 'Pozo ciego / Alt.' },
										{ value: 'no_posee', label: 'No posee' },
									]}
									placeholder="Seleccionar..."
								/>
							</div>
						</div>
					</div>

					{/* Servicios Complementarios y Seguridad */}
					<div className="grid grid-cols-1 md:grid-cols-2 gap-8 pt-4 border-t border-slate-200">
						<div>
							<Label className="mb-3 block font-bold text-slate-700">Servicios Complementarios</Label>
							<div className="grid grid-cols-2 gap-2">
								{['Internet', 'Telefonía fija', 'Alumbrado perimetral', 'Sistema de riego', 'Cámaras de seguridad', 'Sistema de alarmas'].map(item => (
									<div key={item} className="flex items-center space-x-2">
										<input type="checkbox" name={`srv_comp_${item.toLowerCase().replace(/ /g, '_')}`} checked={!!data[`srv_comp_${item.toLowerCase().replace(/ /g, '_')}`]} onChange={handleCheck} />
										<span className="text-[13px] text-slate-600">{item}</span>
									</div>
								))}
							</div>
						</div>
						<div>
							<Label className="mb-3 block font-bold text-slate-700">Seguridad e Instalaciones</Label>
							<div className="grid grid-cols-2 gap-2">
								{['Matafuegos reglamentarios', 'Señalización de emergencia', 'Tablero eléctrico reglamentario', 'Instalación de gas habilitada', 'Seguro de responsabilidad civil'].map(item => (
									<div key={item} className="flex items-center space-x-2">
										<input type="checkbox" name={`seg_${item.toLowerCase().replace(/ /g, '_')}`} checked={!!data[`seg_${item.toLowerCase().replace(/ /g, '_')}`]} onChange={handleCheck} />
										<span className="text-[13px] text-slate-600">{item}</span>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</section>
			
			{/* SECCIÓN 4: DETALLES DE CANTINA (Condicional) */}
			{data.buffetCantina && (
				<section className="mt-4 mb-10 p-6 bg-slate-50 border border-slate-200 rounded-xl animate-in fade-in duration-500">
					<div className="flex items-center justify-between mb-6 border-b pb-4">
						<h4 className="text-lg font-bold text-slate-800 flex items-center">
							Cantina o buffet
						</h4>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 gap-8">
						{/* Columna Izquierda: Explotación */}
						<div className="space-y-4">
							<Label className="font-bold text-blue-700">Modalidad de explotación</Label>
							<Select_simple
								name="cantinaExplotacion"
								value={data.cantinaExplotacion || ''}
								onChange={handleChange}
								options={[
									{ value: 'directa', label: 'Administrada por la institución' },
									{ value: 'concesionada', label: 'Concesionada a terceros' },
								]}
								placeholder="Seleccionar..."
							/>

							{data.cantinaExplotacion === 'concesionada' && (
								<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4 bg-white rounded-lg border border-blue-100 animate-in slide-in-from-left-2">
									<div>
										<Label className="text-xs">Tipo de contrato</Label>
										<Select_simple
											name="cantinaTipoContrato"
											value={data.cantinaTipoContrato || ''}
											onChange={handleChange}
											options={[
												{ value: 'concesion', label: 'Concesión' },
												{ value: 'locacion', label: 'Locación' },
												{ value: 'permiso', label: 'Permiso de uso' },
											]}
											placeholder="Seleccionar..."
										/>
									</div>
									<div>
										<Label className="text-xs">Vigencia (aprox.)</Label>
										<Input
											name="cantinaVigencia"
											placeholder="Ej: Dic 2026"
											value={data.cantinaVigencia || ''}
											onChange={handleChange}
										/>
									</div>
								</div>
							)}
						</div>

						{/* Columna Derecha: Equipamiento (Lista Exacta del PDF) */}
						<div className="space-y-3">
							<Label className="font-bold text-blue-700">Equipamiento disponible</Label>
							<div className="grid grid-cols-1 sm:grid-cols-2 gap-2 bg-white p-4 rounded-lg border">
								{[
									{ id: 'eq_cocina', label: 'Cocina' },
									{ id: 'eq_heladeras', label: 'Heladeras / Freezers' },
									{ id: 'eq_parrilla', label: 'Parrilla' },
									{ id: 'eq_horno', label: 'Horno' },
									{ id: 'eq_barra', label: 'Barra de atención' },
									{ id: 'eq_mesas', label: 'Mesas y sillas' },
									{ id: 'eq_deposito', label: 'Depósito de alimentos' },
								].map(item => (
									<div key={item.id} className="flex items-center space-x-2">
										<input
											type="checkbox"
											id={item.id}
											name={item.id}
											checked={!!data[item.id]}
											onChange={handleCheck}
											className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
										/>
										<Label htmlFor={item.id} className="text-sm font-normal cursor-pointer">
											{item.label}
										</Label>
									</div>
								))}
							</div>
						</div>
						<div>
							{/* Habilitación Bromatológica - Separada del equipamiento */}
							<div className="flex items-center space-x-4 bg-white p-2 px-4 rounded-lg border shadow-sm">
								<span className="text-sm font-semibold text-slate-700">¿Cuenta con habilitación bromatológica municipal?</span>
								<div className="flex items-center space-x-4">
									<label className="flex items-center space-x-1 cursor-pointer">
										<input
											type="radio"
											name="habBromatologica"
											value="si"
											checked={data.habBromatologica === 'si'}
											onChange={handleChange}
											className="text-blue-600 focus:ring-blue-500"
										/>
										<span className="text-sm">Sí</span>
									</label>
									<label className="flex items-center space-x-1 cursor-pointer">
										<input
											type="radio"
											name="habBromatologica"
											value="no"
											checked={data.habBromatologica === 'no'}
											onChange={handleChange}
											className="text-blue-600 focus:ring-blue-500"
										/>
										<span className="text-sm">No</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</section>
			)}

			{/* SECCIÓN IV: PLANOS E INFORMACIÓN EDILICIA */}
			<section className="mb-10">
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					Planos e información edilicia
				</h3>

				<div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-slate-50 p-6 rounded-xl border border-slate-200">

					{/* Pregunta Principal */}
					<div className="space-y-4">
						<Label className="font-bold text-slate-700">¿La institución posee planos de las instalaciones?</Label>
						<Select_simple
							name="poseePlanos"
							value={data.poseePlanos || ''}
							onChange={handleChange}
							options={[
								{ value: 'si', label: 'Sí' },
								{ value: 'no', label: 'No' },
								{ value: 'parciales', label: 'Parciales' },
							]}
							placeholder="Seleccionar..."
						/>
					</div>

					{/* Condicional: Si posee planos o parciales */}
					{(data.poseePlanos === 'si' || data.poseePlanos === 'parciales') && (
						<div className="space-y-4 animate-in fade-in slide-in-from-right-2">
							<Label className="font-bold text-slate-700">Tipo de documentación disponible</Label>
							<Select_simple
								name="tipoDocumentacion"
								value={data.tipoDocumentacion || ''}
								onChange={handleChange}
								options={[
									{ value: 'aprobado', label: 'Plano de obra aprobado' },
									{ value: 'sin_aprobar', label: 'Plano de obra sin aprobar' },
									{ value: 'croquis', label: 'Croquis o plano interno' },
								]}
								placeholder="Seleccionar..."
							/>
						</div>
					)}
				</div>

				{(data.poseePlanos === 'si' || data.poseePlanos === 'parciales') && (
					<div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-slate-50 p-6 rounded-xl border border-slate-200">
						<div className="grid grid-cols-2 gap-4">
							<div>
								<Label className="text-xs">Organismo que aprobó</Label>
								<Input
									name="planosOrganismo"
									placeholder="Ej: Municipalidad"
									value={data.planosOrganismo || ''}
									onChange={handleChange}
								/>
							</div>
							<div>
								<Label className="text-xs">Año aprox. aprobación</Label>
								<Input
									type="number"
									name="planosAnio"
									placeholder="Ej: 1995"
									value={data.planosAnio || ''}
									onChange={handleChange}
								/>
							</div>
						</div>

						<div className="space-y-2">
							<Label className="font-bold text-slate-700">¿Las construcciones coinciden con los planos?</Label>
							<Select_simple
								name="planosCoinciden"
								value={data.planosCoinciden || ''}
								onChange={handleChange}
								options={[
									{ value: 'si', label: 'Sí' },
									{ value: 'parcialmente', label: 'Parcialmente' },
									{ value: 'no', label: 'No' },
								]}
								placeholder="Seleccionar..."
							/>
						</div>
					</div>
				)}

				{/* Documentación Técnica Adicional (Checkboxes) */}
				{(data.poseePlanos === 'si' || data.poseePlanos === 'parciales') && (

					<div className="mt-6 p-4 border rounded-lg bg-white">
						<Label className="mb-3 block font-bold text-blue-700 underline decoration-blue-200 underline-offset-4">
							Documentación técnica adicional:
						</Label>
						<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
							{[
								{ id: 'plano_electrico', label: 'Planos eléctricos' },
								{ id: 'plano_gas', label: 'Planos de gas' },
								{ id: 'plano_estructural', label: 'Planos estructurales' },
								{ id: 'plano_ampliacion', label: 'Planos de ampliaciones' },
							].map(item => (
								<div key={item.id} className="flex items-center space-x-2">
									<input
										type="checkbox"
										id={item.id}
										name={item.id}
										checked={!!data[item.id]}
										onChange={handleCheck}
										className="rounded border-gray-300 text-blue-600"
									/>
									<Label htmlFor={item.id} className="text-xs font-normal cursor-pointer uppercase">
										{item.label}
									</Label>
								</div>
							))}
						</div>
					</div>

				)}
			</section>

			{/* SECCIÓN VI: ACCESIBILIDAD */}
			<section className="mb-6">
				<h3 className="text-xl font-bold mb-4 border-b-2 border-blue-500 pb-2 text-slate-800">
					Accesibilidad
				</h3>

				<div className="bg-slate-50 p-6 rounded-xl border border-slate-200">
					<Label className="font-bold text-slate-700 mb-4 block">
						¿El predio cuenta con accesibilidad para personas con discapacidad?
					</Label>

					<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
						{[
							{ id: 'acc_rampas', label: 'Rampas' },
							{ id: 'acc_sanitarios', label: 'Sanitarios adaptados' },
							{ id: 'acc_circulacion', label: 'Circulaciones accesibles' },
							{ id: 'acc_senaletica', label: 'Señalética' },
						].map(item => (
							<div
								key={item.id}
								className="flex items-center space-x-3 p-2 bg-white rounded-md border border-slate-100 shadow-sm hover:bg-blue-50 transition-colors"
							>
								<input
									type="checkbox"
									id={item.id}
									name={item.id}
									checked={!!data[item.id]}
									onChange={handleCheck}
									className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
								/>
								<Label
									htmlFor={item.id}
									className="text-[14px] text-slate-700 cursor-pointer select-none font-medium"
								>
									{item.label}
								</Label>
							</div>
						))}
					</div>
				</div>
			</section>

		</div>
	);
};

export default TabIV_Infra;
